<div class="container-fluid">
    <div class="row ">
        <div class="col-md-8">
            <div class="row g-3">
                <div class="col-12">
                    <div class="card shadow-sm">
                        <div class="card-header">
                            <h3 class="card-title">Regulation Details</h3>
                        </div>
                        <div class="card-body">
                            <regulations-form [regulation]="regulation" [readonlyRegulationsForm]="readonly"/>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <translations-details [readonlyTranslationsDetails]="readonly"
                        [translations]="translations"></translations-details>
                </div>
                <div class="col-12">
                <regulations-categories [regulationCategory]="category" [readonlyRegulationsCategories]="readonly" />
            </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="col-md-12">
            <regulations-changes-logs [auditLogs]="auditLogs"/>
        </div>
        </div>
    </div>
</div>